import { render, staticRenderFns } from "./equipamiento.vue?vue&type=template&id=71d02fdc&scoped=true&"
import script from "./equipamiento.vue?vue&type=script&lang=js&"
export * from "./equipamiento.vue?vue&type=script&lang=js&"
import style0 from "./equipamiento.vue?vue&type=style&index=0&id=71d02fdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d02fdc",
  null
  
)

export default component.exports